import { useState } from "react";

interface FilterBarProps {
  genres: string[];
  regions: string[];
  years: string[];
  sorts: { key: string; label: string }[];
  region: string;
  year: string;
  sort: string;
  genre: string;
  onRegion: (v: string) => void;
  onYear: (v: string) => void;
  onSort: (v: string) => void;
  onGenre: (v: string) => void;
}

function Chips({
  label,
  options,
  value,
  onSelect,
}: {
  label: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="w-14 shrink-0 text-xs font-medium text-foreground-500">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <button
            key={o}
            type="button"
            onClick={() => onSelect(o)}
            className={`rounded-full px-3 py-1 text-xs transition-colors cursor-pointer whitespace-nowrap ${
              value === o
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-700"
            }`}
          >
            {o}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar(props: FilterBarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between px-4 py-3 md:hidden cursor-pointer"
      >
        <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
          <i className="ri-filter-3-line text-primary-600" />
          筛选条件
        </span>
        <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
      </button>

      <div className={`${open ? "block" : "hidden"} px-4 pb-4 md:block md:pb-5 md:pt-5`}>
        <div className="space-y-4">
          <Chips label="类型" options={props.genres} value={props.genre} onSelect={props.onGenre} />
          <Chips label="地区" options={props.regions} value={props.region} onSelect={props.onRegion} />
          <Chips label="年份" options={props.years} value={props.year} onSelect={props.onYear} />
          <div className="flex flex-wrap items-center gap-2">
            <span className="w-14 shrink-0 text-xs font-medium text-foreground-500">排序</span>
            <div className="flex gap-2">
              {props.sorts.map((s) => (
                <button
                  key={s.key}
                  type="button"
                  onClick={() => props.onSort(s.key)}
                  className={`flex items-center gap-1 rounded-full px-3 py-1 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                    props.sort === s.key
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-accent-50 hover:text-accent-700"
                  }`}
                >
                  {s.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}